import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { pessimisticUpdate } from '@nx/angular';
import * as NotificationTriggersActions from './notification-triggers.actions';
import { NotificationsApiService } from '../../../../../shared/services/src/lib/notifications/notifications-api.service';
import { map, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';

@Injectable()
export class NotificationTriggersEffects {
  loadNotificationTriggers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationTriggersActions.loadNotificationTriggers),
      withLatestFrom(this.store.select(getSelectedOrganizationInfo)),
      pessimisticUpdate({
        run: (
          action: ReturnType<
            typeof NotificationTriggersActions.loadNotificationTriggers
          >,
          org
        ) => {
          const { notificationTypes, targetIds, locationIds } = action;
          return this.notificationsService
            .getNotificationTriggers({
              entityId: org.id,
              notificationTypes,
              targetIds,
              locationIds,
            })
            .pipe(
              map((res) =>
                NotificationTriggersActions.loadNotificationTriggersSuccess({
                  notificationTriggers: res,
                })
              )
            );
        },

        onError: (
          action: ReturnType<
            typeof NotificationTriggersActions.loadNotificationTriggers
          >,
          error
        ) => {
          console.error('Error', error);
          return NotificationTriggersActions.loadNotificationTriggersFailure({
            error,
          });
        },
      })
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private notificationsService: NotificationsApiService
  ) {}
}
